/**
 * «Сторінку не знайдено» with «До об'єктів»: inside the app when signed in,
 * on the sign-in ground otherwise.
 */
import { Link } from 'react-router-dom';

import { AppShell, homePath } from '../../components/AppShell.js';
import { AuthLayout } from '../../components/AuthLayout.js';
import { useProfile } from '../../hooks/use-profile.js';
import { useT } from '../../i18n/locale-context.js';

export function NotFoundCard({ bare = false }: { bare?: boolean }) {
  const t = useT();
  const { data: profile } = useProfile();
  return (
    <section className={bare ? 'empty-card' : 'card empty-card'}>
      <h1>{t('notfound.title')}</h1>
      <p className="sub">{t('notfound.sub')}</p>
      <Link className="btn primary" to={profile ? homePath(profile.role) : '/login'}>
        {t('notfound.back')}
      </Link>
    </section>
  );
}

export function NotFoundPage() {
  const { data: profile, isLoading } = useProfile();
  if (isLoading) return null;
  if (!profile) {
    return (
      <AuthLayout>
        <NotFoundCard bare />
      </AuthLayout>
    );
  }
  return (
    <AppShell>
      <div className="view">
        <NotFoundCard />
      </div>
    </AppShell>
  );
}
